import { Check, Loader2, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { planFeatures } from "../../lib/plans";

// Full-width promo for the free plan, shown above the plan tabs.
export default function FreeTrialBanner({ plan, onStart, busy, disabled }) {
  const features = planFeatures(plan.limits);
  return (
    <div
      data-testid="free-trial-banner"
      className="mt-8 flex flex-col gap-6 rounded-2xl bg-gradient-to-r from-[#FF6B00] to-[#FF9A3D] p-6 text-white mb-card-shadow sm:p-8 lg:flex-row lg:items-center lg:justify-between"
    >
      <div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide">
          <Sparkles className="h-3.5 w-3.5" />
          {plan.name}
        </span>
        <h2 className="mt-3 text-2xl font-extrabold sm:text-3xl">Start your free trial today</h2>
        <p className="mt-1 text-white/90">No credit card required.</p>
        {features.length > 0 && (
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-1.5 text-sm text-white/95">
                <Check className="mt-0.5 h-4 w-4 shrink-0" />
                {f}
              </li>
            ))}
          </ul>
        )}
      </div>
      <Button
        onClick={() => onStart(plan)}
        disabled={disabled}
        size="lg"
        className="shrink-0 bg-white px-8 font-bold text-[#FF6B00] hover:bg-white/90"
        data-testid="free-trial-start"
      >
        {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Start Free Trial
      </Button>
    </div>
  );
}
